/*
 * Loads the footer country options on demand instead of rendering ~240 items in every page.
 * The list is fetched when the selector nears the viewport or is interacted with, then the
 * popout-select element is told about the new options.
 */
(() => {
  const SECTION_URL = `${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}?section_id=localization-country-list`;
  let request = null;

  const fetchItems = () => {
    if (!request) {
      request = fetch(SECTION_URL, { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
        .catch((error) => {
          request = null;
          throw error;
        });
    }
    return request;
  };

  const fill = (list) => {
    if (list.dataset.lazyState) return;
    list.dataset.lazyState = 'loading';

    fetchItems()
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = doc.querySelectorAll('li');
        if (list.dataset.lazyCountries !== 'true') {
          doc.querySelectorAll('.popout__flag').forEach((flag) => flag.remove());
        }
        list.append(...items);
        list.dataset.lazyState = 'done';

        const popout = list.closest('popout-select');
        if (popout && typeof popout._connectOptions === 'function') {
          popout.popoutOptions = list.querySelectorAll('[data-popout-option]');
          popout._connectOptions();
          if (typeof popout.popupListSetDimensions === 'function') popout.popupListSetDimensions();
        }
      })
      .catch(() => {
        delete list.dataset.lazyState;
      });
  };

  const init = () => {
    const lists = document.querySelectorAll('[data-lazy-countries]:not([data-lazy-init])');
    lists.forEach((list) => {
      list.dataset.lazyInit = '';
      const popout = list.closest('popout-select') || list.parentElement;
      ['pointerover', 'focusin', 'touchstart'].forEach((type) => {
        popout.addEventListener(type, () => fill(list), { once: true, passive: true });
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            observer.disconnect();
            fill(list);
          }
        }, { rootMargin: '400px 0px' });
        observer.observe(popout);
      }
    });
  };

  init();
  document.addEventListener('shopify:section:load', init);
})();
